export const COMMENT_TYPE_POSITIVE = 3 // 正面
export const COMMENT_TYPE_NEUTRAL = 2 // 中立
export const COMMENT_TYPE_NEGATIVE = 1 // 负面

export const COMMENT_TYPES = [
  { name: '正面评论', id: COMMENT_TYPE_POSITIVE },
  { name: '中立评论', id: COMMENT_TYPE_NEUTRAL },
  { name: '负面评论', id: COMMENT_TYPE_NEGATIVE }
]

export const VISIBLE_TYPE_VISIBLE = 2
export const VISIBLE_TYPE_INVISIBLE = 1
export const VISIBLE_TYPE_UNKNOWN = -1
export const VISIBLE_TYPES = [
  { name: '未隐藏', id: VISIBLE_TYPE_VISIBLE },
  { name: '已隐藏', id: VISIBLE_TYPE_INVISIBLE },
  { name: '未知', id: VISIBLE_TYPE_UNKNOWN }
]

export const REPLY_TYPE_REPLY = 1
export const REPLY_TYPE_NOT_REPLY = 2
export const REPLY_TYPES = [
  { name: '已回复', id: REPLY_TYPE_REPLY },
  { name: '未回复', id: REPLY_TYPE_NOT_REPLY }
]

export const REPLY_LEVEL_ONE = 1
export const REPLY_LEVEL_TWO = 2
export const REPLY_LEVEL_THREE = 3
export const REPLY_LEVEL_TYPES = [
  { name: '一级评论', id: REPLY_LEVEL_ONE },
  { name: '二级评论', id: REPLY_LEVEL_TWO },
  { name: '三级评论', id: REPLY_LEVEL_THREE }
]
